import React, { useContext } from "react";
import {ThemeContext} from '../Helper/Context'

const LoginNotification = () => { 
    const {setShowSignin, mainState, setMainState} = useContext(ThemeContext);

    const handleOnclick = (e) =>{
        e.preventDefault();
        setMainState({...mainState,section:'signup'})
    }
    return (
        <>
        <div className="login-notification">
            <div className="text-wrapper">
                <p>Are you already registered with us, as a member or parent? Please sign in to your account, or if you are new, sign up!</p>
            </div>
            <div className="btn-wrapper">
                <button className="btn btn-yellow" onClick={e => setShowSignin(true)}>Sign in</button>
                <button className="btn btn-blue" onClick={e => handleOnclick(e)}>Sign up</button>
            </div>
        </div>
        </>
    )
}

export default LoginNotification
